import { useTranslation } from 'react-i18next';
import React from 'react';
import { onImageError, productImage } from '../helper';
import { Product } from '../interfaces/orderSaleProduct';
import styles from '../product-timeline.module.scss';
import { Icon } from '../fake';

const ProductView: React.FC<{
  product: Product;
  isSeller: boolean;
}> = ({ product, isSeller }) => {
  const { t } = useTranslation();
  const { productName, brandName, productPrice, imageUrl, ezlink, isDirectShipping, productId, externalRef } = product;
  return (
    <div className={styles.ordersSales__mainRight__product}>
      <div className={styles.ordersSales__mainRight__product__left}>
        <a
          href={ezlink}
          rel={'noreferrer'}
          target={'_blank'}
        >
          <img
            className={styles.ordersSales__mainRight__product__left__image}
            src={productImage(imageUrl)}
            alt={productName}
            onError={onImageError}
          />
        </a>
      </div>
      <div className={styles.ordersSales__mainRight__product__right}>
        <div className={styles.ordersSales__mainRight__product__right__name}>{brandName}</div>
        <div className={styles.ordersSales__mainRight__product__right__type}>{productName}</div>
        <div className={styles.ordersSales__mainRight__product__right__price}>
          {t('MY_ACCOUNT.ORDERS_SALES.LIST.REF')}. {productId}
        </div>
        {externalRef && <div className={styles.ordersSales__mainRight__product__right__price}>{externalRef}</div>}
        {isSeller && <div className={styles.ordersSales__mainRight__product__right__price}>{productPrice}</div>}
        {isDirectShipping && (
          <div className={styles.ordersSales__mainRight__product__right__directShipping}>
            <Icon
              className={styles.ordersSales__mainRight__product__right__directShipping__icon}
              name="handshake"
            />
            <div className={styles.ordersSales__mainRight__product__right__directShipping__text}>
              {t('MY_ACCOUNT.ORDERS_SALES.DIRECT_SHIPPING')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductView;
